import { render, staticRenderFns } from "./SidebarDashboard.vue?vue&type=template&id=626e196c"
import script from "./SidebarDashboard.vue?vue&type=script&lang=js"
export * from "./SidebarDashboard.vue?vue&type=script&lang=js"
import style0 from "./SidebarDashboard.vue?vue&type=style&index=0&id=626e196c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports